
import { Attachment, FileGenerationStatus, Message, MessageRole, MessageDeliveryStatus, Mention } from '../types/chat';
import { CustomGpt } from '../types/custom-gpt.types';
import { CustomGptHeader } from './CustomGptHeader';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { useEffect, useRef } from 'react';
import { ArrowDown, Copy, FileText, Loader2, RotateCw } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import logo from '../../../assets/images/bebrave-logo.png';
// import logo from '../../../assets/images/bebrave-logo.png';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import { modelSupportedExtensionsMap, ModelTypes } from '../types/model.types';
import { ImagePreview } from './ImagePreview';
import { useToast } from '../../../hooks/use-toast';
import ExpandableThinkContainer from './ExpandableThinkContainer';
import { useTranslation } from 'react-i18next';
import { Feedback } from './Feedback';
import { useTheme } from '../../../components/core/theme-provider';
import { ChangeMessage } from './ChangeMessage';
import { MessageLoading } from './MessageLoading';
import { AssistantAttachmentPreview } from './AssistantAttachmentPreview';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../../../components/ui/table';
import userParticipant from 'assets/images/userParticipant.png'
// import replyIcon from 'assets/images/reply.svg'
// import commentIcon from 'assets/images/comment.svg'



import { useChatStore } from '../../../state/store/chat/use-chat-store';
import { useConfig } from '../../../hooks/use-config';
import SourceFile from './SourceFile';
import { isValidUrl, placeHrefInContent } from 'utils/chat-utilities';
import { SearchSources } from './SearchSources';
import SearchRelatedList from './SearchRelatedList';
import SearchRelatedImageList from './SearchRelatedImageList';
import SearchRelatedVideoList from './SearchRelatedVideoList';
import { AnalyzingIndicator } from './AnalyzingIndicator';
import { trackEvent } from 'analytics/tracker';
import { EVENTS } from 'analytics/events';


// import { useLocation } from 'react-router-dom';
// import { hasValidGroupChatComponentRoute } from 'pages/services/utilityService';
// import {
//     DropdownMenu,
//     DropdownMenuContent,
//     DropdownMenuGroup,
//     DropdownMenuItem,
//     DropdownMenuTrigger,
// } from '../../../components/ui/dropdown-menu';
import { formatDate } from '../../../utils/custom-date';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '../../../components/ui/tooltip';
import ChatEvents from './ChatEvents';
import { IamData } from '/features/iam/services/user-service';
import ReplyButton from './ReplyButton';
import ReplyBubble from './ReplyBubble';
// import { formatDate } from '/utils/custom-date';
// import { useModelStore } from 'state/store/chat/use-model-store';
// import { useAuthStore } from '../../../state/store/auth/useAuthStore';


// import ThinkingLoader from './ThinkingLoader';
// import eagleApp from 'assets/images/eagleApp.png'

const formatDayAndTime = (date: Date): string => {
    // const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    // const dayName = days[date.getDay()];

    const hours = date.getHours();
    const minutes = date.getMinutes();
    // const ampm = hours >= 12 ? 'pm' : 'am';
    // hours = hours
    // hours = hours

    const minutesStr = minutes.toString().padStart(2, '0');
    return `${hours}:${minutesStr}`;
};

const formatTimeWithAMPM = (date: Date): string => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    const day = days[date.getDay()];
    const minutesStr = minutes.toString().padStart(2, '0');
    return `${day} ${displayHours}:${minutesStr} ${ampm}`;
};

interface ChatMessagesProps {
    messages: Message[];
    isLoading: boolean;
    streamingMessage: Message | undefined;
    isStillGenerating: boolean;
    chatInputHeight?: number;
    onSendMessage?: (content: string, files: Attachment[]) => void;
    currentUser?: {
        id: string;
        email: string;
        firstName: string;
        lastName: string;
        profileImageUrl?: string;
    } | null;
    hasParticipants?: boolean;
    participants?: IamData[];
    removedParticipants?: IamData[];
    associatedAssistant?: CustomGpt | null;
}

export const GroupChatMessages = ({
    messages,
    isLoading,
    streamingMessage,
    isStillGenerating,
    chatInputHeight = 186,
    onSendMessage,
    currentUser,
    participants,
    removedParticipants,
    associatedAssistant,
}: ChatMessagesProps) => {
    const { t } = useTranslation();
    const { configurationSettings } = useConfig();
    console.log('isStillGenerating', isStillGenerating)
    // const selectedModel = useModelStore((state) => state.selectedModel);
    // console.log('streamingMessage', streamingMessage)
    // console.log('messages in groupChatMessages', messages, "streamingMessage", streamingMessage)



    // const currentUser = useAuthStore((state: any) => state.user);


    // console.log('streamingMessage in groupChatMessages in groupChatMessages', messages)
    // Use participants from current conversation instead of global hasParticipantsArray
    const activeConversationId = useChatStore((state) => state.activeConversationId);
    const currentConversation = useChatStore((state) =>
        activeConversationId ? state.conversations[activeConversationId] : null
    );
    const hasParticipantsArray = currentConversation?.participants || [];
    const hasRemovedParticipantsArray = currentConversation?.removedParticipants || [];

    const hasParticipants = hasParticipantsArray && hasParticipantsArray?.length > 0

    // const setCommentMessage = useChatStore((state) => state.setCommentMessage);
    // const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);
    const setReplyMessage = useChatStore((state) => state.setReplyMessage);


    const messagesEndRef = useRef<HTMLDivElement>(null);
    const messageContainerRef = useRef<HTMLDivElement>(null);
    const scrollToBottomButton = useRef<HTMLButtonElement>(null);
    const isUserAtBottomRef = useRef<boolean>(true);
    // const { pathname } = useLocation();
    const { toast } = useToast();
    const { theme } = useTheme();
    console.log('first')

    const isAtBottom = (): boolean => {
        if (!messageContainerRef.current) return true;
        const { scrollTop, clientHeight, scrollHeight } = messageContainerRef.current;
        // Check if user is within 50px of the bottom
        return scrollHeight - (scrollTop + clientHeight) < 50;
    };

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        scrollToBottomButton.current?.style.setProperty('display', 'none');
    };

    // Auto-scroll when new messages arrive
    useEffect(() => {
        if (messages.length > 0) {
            const lastMessage = messages[messages.length - 1];
            const isUserMessage = lastMessage.role === MessageRole.USER_CHAT;
            const isCurrentUserMessage = isUserMessage && lastMessage.senderId === currentUser?.id;

            // Always scroll to bottom if current user sent a message, otherwise only if user is at bottom
            if (isCurrentUserMessage || isUserAtBottomRef.current) {
                requestAnimationFrame(() => {
                    scrollToBottom();
                    // Update ref to true when we auto-scroll for user message
                    if (isCurrentUserMessage) {
                        isUserAtBottomRef.current = true;
                    }
                });
            }
        }
    }, [messages.length, messages[messages.length - 1]?.recordId, currentUser?.id]);

    // Auto-scroll during streaming (only if user is at bottom)
    useEffect(() => {
        if (!isStillGenerating) return;

        // During streaming, continuously scroll if user is at bottom
        const scrollInterval = setInterval(() => {
            if (isUserAtBottomRef.current && isAtBottom()) {
                scrollToBottom();
            }
        }, 150); // Check every 150ms during streaming

        return () => clearInterval(scrollInterval);
    }, [isStillGenerating]);

    // Track scroll position
    useEffect(() => {
        const handleScroll = () => {
            if (messageContainerRef.current) {
                const atBottom = isAtBottom();
                isUserAtBottomRef.current = atBottom;

                if (atBottom) {
                    scrollToBottomButton.current?.style.setProperty('display', 'none');
                } else {
                    scrollToBottomButton.current?.style.setProperty('display', 'flex');
                }
            }
        };

        const container = messageContainerRef.current;
        container?.addEventListener('scroll', handleScroll);

        return () => {
            container?.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const fallbackCopyToClipboard = (text: string) => {
        const tempTextArea = document.createElement('textarea');
        tempTextArea.value = text;
        document.body.appendChild(tempTextArea);
        tempTextArea.select();

        try {
            document.execCommand('copy');
            console.log('Text copied to clipboard successfully!');
        } catch (err) {
            console.error('Failed to copy using execCommand: ', err);
        } finally {
            document.body.removeChild(tempTextArea);
        }
    };

    const handleCopyToClipboard = (text: string) => {
        try {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(() => {
                    console.log('Text copied to clipboard successfully!');
                });
            } else {
                fallbackCopyToClipboard(text);
            }
            toast({
                variant: 'success',
                title: t('COPIED'),
                description: t('TEXT_COPY_SUCCESS'),
            });
        } catch (err) {
            console.error('Failed to copy text: ', err);
            toast({
                variant: 'destructive',
                title: t('FAILED_TO_COPY_TEXT'),
                description: t('FAILED_COPY_TO_CLIPBOARD'),
            });
        }
    };

    const copyImageToClipboard = async (fileId: string) => {
        try {
            const itemIdFilePathMap = useChatStore.getState().itemIdFilePathMap;
            const imageSrc = itemIdFilePathMap.get(fileId);

            if (!imageSrc) {
                toast({
                    variant: 'destructive',
                    title: t('FAILED_TO_COPY_IMAGE'),
                    description: t('FAILED_COPY_IMAGE_TO_CLIPBOARD'),
                });
                return;
            }

            try {
                const response = await fetch(imageSrc);
                if (!response.ok) {
                    trackEvent(EVENTS.ERROR(new Error("Failed to copy image"), {
                        endpoint: imageSrc,
                        method: 'GET',
                        status: response.status
                    }));
                }
                const blob = await response.blob();
                const imageBlob = new Blob([blob], { type: 'image/png' });

                await navigator.clipboard.write([
                    new ClipboardItem({
                        'image/png': imageBlob,
                    }),
                ]);

                toast({
                    variant: 'success',
                    title: t('COPIED'),
                    description: t('IMAGE_COPY_SUCCESS'),
                });
                return;
            } catch (clipboardError) {
                console.warn('Clipboard API failed, falling back to download:', clipboardError);
            }
        } catch (error) {
            console.error('Failed to copy/download image:', error);
            toast({
                variant: 'destructive',
                title: t('FAILED_TO_COPY_IMAGE'),
                description: t('FAILED_COPY_IMAGE_TO_CLIPBOARD'),
            });
        }
    };

    const copyChatBubbleIcons = [
        {
            icon: <Copy size={16} />,
            onClick: async (text: string, hasImage?: boolean, fileId?: string) => {
                if (hasImage && fileId && navigator.clipboard && window.isSecureContext) {
                    await copyImageToClipboard(fileId);
                } else handleCopyToClipboard(text);
            },
            type: 'icon',
            tooltip: t('COPY'),
        },
    ];

    const escapeHtml = (value: string): string => {
        return value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    const hasTripleBackticks = (value: string): boolean => value.includes('```');

    const escapeRegex = (value: string): string => {
        return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    const buildMentionLabels = (): string[] => {
        const allUsers = [...(participants || []), ...(removedParticipants || [])];
        const labels = allUsers
            .map((u) => `${u.firstName ?? ''}${u.lastName ? ` ${u.lastName}` : ''}`.trim())
            .filter((x) => Boolean(x));

        // Include model mention
        labels.push('EagleGpt');

        // Deduplicate (case-insensitive)
        const seen = new Set<string>();
        return labels.filter((l) => {
            const key = l.toLowerCase();
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    };

    const applyMentionHighlighting = (content: string, mentions?: Mention[]): string => {
        // If content already contains HTML entities or tags, skip processing to avoid double-encoding
        // Check for both encoded HTML entities and actual HTML tags
        if (content.includes('&lt;') || content.includes('&gt;') || content.includes('<span') || content.includes('</span>')) {
            return content;
        }

        // Prefer backend ranges when present
        if (!mentions || mentions.length === 0) {
            // Fallback: if we have a code block, don't apply regex highlighting (can break formatting).
            // If mention ranges exist, they are still handled above.
            if (hasTripleBackticks(content)) return content;

            // Best-effort fallback for persisted messages that don't include mention ranges:
            // Try matching full display names (including spaces) from known participants first.
            const mentionLabels = buildMentionLabels().sort((a, b) => b.length - a.length);
            if (mentionLabels.length > 0) {
                const labelAlternation = mentionLabels
                    .map((label) => escapeRegex(label).replace(/\s+/g, '\\s+'))
                    .join('|');

                if (labelAlternation) {
                    const fullNameRegex = new RegExp(
                        `(^|[\\s(])@(${labelAlternation})(?=$|[\\s\\n\\t.,!?;:)])`,
                        'gi'
                    );

                    const replaced = content.replace(
                        fullNameRegex,
                        (_match, prefix: string, name: string) => {
                            // keep the exact matched casing/spaces from the message
                            const safe = escapeHtml(String(name));
                            return `${prefix}<span class="font-semibold text-primary">@${safe}</span>`;
                        }
                    );

                    if (replaced !== content) return replaced;
                }
            }

            // Fallback fallback: highlight @token (single word)
            const tokenRegex = /(^|[\s(])@([A-Za-z0-9._-]+)/g;
            return content.replace(tokenRegex, (_match, prefix: string, name: string) => {
                return `${prefix}<span class="font-semibold text-primary">@${escapeHtml(
                    String(name)
                )}</span>`;
            });
        }

        // Build result by processing original content and inserting spans at mention positions
        // First, deduplicate mentions - remove only exact duplicates (same start, end, and userId)
        const uniqueMentions: Mention[] = [];
        const seenRanges = new Set<string>();

        for (const mention of mentions) {
            // Create a key for this mention range (exact position)
            const rangeKey = `${mention.start}-${mention.end}-${mention.userId}`;

            // Only skip if we've already processed this EXACT range (same position)
            // Allow multiple mentions of the same user at different positions
            if (!seenRanges.has(rangeKey)) {
                uniqueMentions.push(mention);
                seenRanges.add(rangeKey);
            }
        }

        // Sort mentions by start position (ascending) to process in order
        const sortedMentions = uniqueMentions
            .filter(m => m.start >= 0 && m.end <= content.length && m.start < m.end)
            .sort((a, b) => a.start - b.start);

        if (sortedMentions.length === 0) {
            return content;
        }

        let result = '';
        let lastIndex = 0;

        // Helper function to highlight @mentions in a text segment
        const highlightMentionsInText = (text: string): string => {
            if (!text) return text;
            // Match @ followed by word characters (alphanumeric, underscore, dots, hyphens)
            const mentionRegex = /@([A-Za-z0-9._-]+)/g;
            return text.replace(mentionRegex, (match, name) => {
                const safe = escapeHtml(name);
                return `<span class="font-semibold text-primary">@${safe}</span>`;
            });
        };

        sortedMentions.forEach((mention) => {
            // Expand to include a preceding '@' if it's outside the provided range
            const adjustedStart =
                mention.start > 0 && content[mention.start - 1] === '@' ? mention.start - 1 : mention.start;

            // Add text before this mention and highlight any @mentions in it
            if (adjustedStart > lastIndex) {
                const textBefore = content.substring(lastIndex, adjustedStart);
                result += highlightMentionsInText(textBefore);
            }

            // Extract mention text from ORIGINAL content (not processed)
            const mentionText = content.substring(adjustedStart, mention.end);
            const safeMentionText = escapeHtml(mentionText);

            // Add the highlighted mention
            result += `<span class="font-semibold text-primary">${safeMentionText}</span>`;

            lastIndex = mention.end;
        });

        // Add remaining text after last mention and highlight any @mentions in it
        if (lastIndex < content.length) {
            const textAfter = content.substring(lastIndex);
            result += highlightMentionsInText(textAfter);
        }

        return result;
    };


    const messageBubbleUi = (
        message: Message,
        index: number,
        hideButtons?: boolean,
    ) => {

        const generation = message.generations[index];
        // console.log('generation in messageBubbleUi', generation)
        // console.log('generation', generation)
        // can we use this code {"step_type": "action", "tool": "python_interpreter", "code": "import pandas as pd\nimport matplotlib.pyplot as plt\n\n# Read the Excel file into a DataFrame\ntry:\n df = pd.read_excel('/tmp/code_interpreter_rusgt571/random_people_200plus.xlsx')\nexcept Exception as e:\n print(f"Failed to read Excel file: {e}")\n # Handle the exception appropriately\n\n# Check if the DataFrame is not empty\nif not df.empty:\n # Assuming there's a column named 'values' or a similar numeric column\n numeric_columns = df.select_dtypes(include=['int64', 'float64']).columns\n \n if len(numeric_columns) > 0:\n # Use the first numeric column found for analysis\n value_column = numeric_columns[0]\n \n # Get the top 10 values\n top_10 = df.nlargest(10, value_column)\n \n # Create a bar chart\n plt.figure(figsize=(10,6))\n plt.bar(top_10.index, top_10[value_column])\n plt.xlabel('Index')\n plt.ylabel(value_column)\n plt.title(f'Top 10 {value_column}')\n plt.xticks(rotation=90) # Rotate x-axis labels for better readability\n \n # Save the plot\n plt.savefig('/tmp/code_artifacts_cchg7pnw/top_10_values_plot.png')\n plt.close()\n \n print("Top 10 values and plot created successfully.")\n else:\n print("No numeric columns found in the data.")\nelse:\n print("The DataFrame is empty.")", "observations": "Execution logs:\nTop 10 values and plot created successfully.\nLast output from code snippet:\n(array([-20., 0., 20., 40., 60., 80., 100.]), [Text(-20.0, 0, '\u221220'), Text(0.0, 0, '0'), Text(20.0, 0, '20'), Text(40.0, 0, '40'), Text(60.0, 0, '60'), Text(80.0, 0, '80'), Text(100.0, 0, '100')])"}}
        // in react markdown


        if (generation.searchSources) {
            generation.content = placeHrefInContent(generation.content, generation.searchSources);
            generation.searchSources = generation.searchSources.filter((source) => {
                return source.metadata?.url && isValidUrl(source.metadata.url);
            });
        }

        const contentWithHighlightedMentions = applyMentionHighlighting(
            generation.content || '',
            generation.mentions
        );

        // Add code execution steps to content if they exist


        const assistantAttachments = generation.attachments?.filter(
            (attachment) => attachment.sender === 'assistant'
        );
        const assistantGeneratedImages = generation.generatedImages?.filter(
            (attachment) => attachment.sender === 'assistant'
        );

        const userAttachments = generation.attachments?.filter(
            (attachment) => attachment.sender === 'user'
        );
        const sources = generation?.sources || [];

        const handleSendMessage = (message: string, files: any[]) => {
            onSendMessage?.(message, files);
        };

        // Helper function to format user name from firstName and lastName
        const formatUserName = (firstName?: string, lastName?: string | null): string => {
            if (!firstName) return 'User';
            return lastName ? `${firstName} ${lastName}` : firstName;
        };

        // Get user message data for assistant messages (shows which user triggered the response)
        const getUserMessageData = (): { userName: string; message: string; createdDate?: number } => {
            if (message.role !== MessageRole.ASSISTANT) {
                return { userName: '', message: '' };
            }

            // console.log('messages', messages, 'message.userRecordId', message.userRecordId)
            const userRecord = messages.find((msg) =>
                (msg.role === MessageRole.USER_CHAT || msg.role === MessageRole.ASSISTANT_CHAT) &&
                msg.recordId === message.userRecordId
            );
            if (!userRecord) {
                return { userName: 'User', message: '' };
            }

            const isCurrentUser = userRecord.senderId === currentUser?.id;
            const participant = participants?.find((p) => p.itemId === userRecord.senderId);
            const removedParticipant = removedParticipants?.find((p) => p.itemId === userRecord.senderId);

            let userName = isCurrentUser
                ? formatUserName(currentUser?.firstName, currentUser?.lastName)
                : formatUserName(removedParticipant?.firstName, removedParticipant?.lastName) || formatUserName(participant?.firstName, participant?.lastName);
            if (isCurrentUser) {
                userName = formatUserName(currentUser?.firstName, currentUser?.lastName);
            } else if (participant) {
                userName = formatUserName(participant?.firstName, participant?.lastName);
            } else if (removedParticipant) {
                userName = formatUserName(removedParticipant?.firstName, removedParticipant?.lastName);
            }


            return {
                userName,
                message: userRecord.generations[0]?.content || '',
                createdDate: userRecord.generations[0]?.createdDate,
            };
        };

        const userMessageData = getUserMessageData();
        // console.log('userMessageData', userMessageData)

        return <>
            {generation.parentMessage && (
                <ReplyBubble message={message} generation={generation} />
            )}
            <div className={` ${message.role === MessageRole.USER_CHAT ? ' min-w-full' : 'w-full flex flex-col'}  mb-1`}>
                <div className={`flex items-center min-w-0 ${message.role === MessageRole.USER_CHAT ? 'justify-end' : 'justify-start'} group`}>

                    {message.role === MessageRole.USER_CHAT && (
                        <>
                            {/* Resend button for failed messages */}
                            {message.deliveryStatus === MessageDeliveryStatus.FAILED && message.senderId === currentUser?.id && (
                                <TooltipProvider>
                                    <Tooltip>
                                        <TooltipTrigger asChild>
                                            <button
                                                className="w-4 h-4 mr-2 rounded-full cursor-pointer hover:opacity-70 transition-opacity flex items-center justify-center opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto focus:opacity-100 focus:pointer-events-auto"
                                                onClick={async () => {
                                                    const retryFailedMessage = useChatStore.getState().retryFailedMessage;
                                                    const activeConversationId = useChatStore.getState().activeConversationId;

                                                    if (retryFailedMessage && activeConversationId && configurationSettings) {
                                                        await retryFailedMessage(message.recordId, configurationSettings, activeConversationId);
                                                    }
                                                }}
                                            >
                                                <RotateCw className={`w-4 h-4 ${theme === 'dark' ? 'text-primary group-hover:text-primary-50' : 'text-primary group-hover:text-primary-50'}`} />
                                            </button>
                                        </TooltipTrigger>
                                        <TooltipContent>
                                            <p>{t('RESEND_MESSAGE') || 'Resend message'}</p>
                                        </TooltipContent>
                                    </Tooltip>
                                </TooltipProvider>
                            )}

                            <ReplyButton hasParticipantsArray={hasParticipantsArray} hasRemovedParticipantsArray={hasRemovedParticipantsArray} message={message} generation={generation} setReplyMessage={setReplyMessage} />
                            {/* <DropdownMenu
                                modal={false}
                                open={openDropdownId === generation.id}
                                onOpenChange={(open) => setOpenDropdownId(open ? generation.id : null)}
                            >
                                <DropdownMenuTrigger asChild>
                                    <button className="w-4 h-4 mr-2 rounded-full object-cover cursor-pointer hover:opacity-70 transition-opacity">
                                        <EllipsisVertical className="w-4 h-4" />
                                    </button>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent className="w-40 rounded-lg p-2 shadow-lg border bg-background" align="start">
                                    <DropdownMenuGroup>
                                        <DropdownMenuItem onClick={() => {
                                            const repliedUser = hasParticipantsArray.find(participant => participant.itemId === message.senderId || currentUser?.id)
                                                || hasRemovedParticipantsArray.find(participant => participant.itemId === message.senderId || currentUser?.id);
                                            // console.log('Reply to message:', repliedUser);
                                            const replyMessageData: ReplyMessageData = {
                                                generation: generation,
                                                repliedUser: repliedUser,
                                            };
                                            setReplyMessage(replyMessageData);
                                            setOpenDropdownId(null);
                                        }}>
                                            <img src={replyIcon} alt="reply" className="w-4 h-4 mr-2" />
                                            <span className={`text-sm font-normal ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[text-[#555555]]'}`}>
                                                Reply
                                            </span>
                                        </DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => {
                                            console.log('Comment on message:', generation.id);
                                            setCommentMessage(message);
                                            setOpenDropdownId(null);
                                        }}>
                                            <img src={commentIcon} alt="copy" className="w-4 h-4 mr-2" />
                                            <span className={`text-sm font-normal ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[text-[#555555]]'}`}>
                                                Comment
                                            </span>
                                        </DropdownMenuItem>
                                    </DropdownMenuGroup>
                                </DropdownMenuContent>
                            </DropdownMenu> */}
                        </>
                    )}

                    <div
                        className={`${(message.role === MessageRole.USER_CHAT || message.role === MessageRole.ASSISTANT_CHAT) ? (theme === 'dark' ? 'bg-[#27272C] p-2' : 'bg-[#F4F4F4] px-[13px] py-[14px] mt-[-10px] z-20') : ''} rounded-[8px] max-w-[100%] `}
                    >
                        <div className="break-words min-w-0">
                            {/* user message that triggered this assistant response */}
                            {userMessageData && message.role === MessageRole.ASSISTANT && (
                                <div className={`py-3.5 px-3 rounded-[20px] w-fit max-w-full mb-2 ${theme === 'dark'
                                    ? 'bg-primary-600'
                                    : 'bg-primary-50'
                                    }`}>
                                    <p className="text-sm leading-relaxed text-foreground line-clamp-2 text-start">
                                        {userMessageData.message}
                                    </p>
                                    <div className="flex items-center justify-end gap-2 mt-2">

                                        <span className={`text-xs font-semibold ${theme === 'dark' ? 'text-[#27272C]' : 'text-[#27272C]'}`}>
                                            {userMessageData.userName}
                                        </span>
                                        <span className={`text-xs font-semibold ${theme === 'dark' ? 'text-[#BCBCBE]' : 'text-[#9C9C9E]'}`}>
                                            {userMessageData.createdDate
                                                ? formatDate(new Date(userMessageData.createdDate))
                                                : ''}
                                        </span>
                                    </div>
                                </div>
                            )}

                            {(message.role === MessageRole.USER_CHAT) && userAttachments && userAttachments.length > 0 && (
                                <div className="flex flex-col items-end justify-end gap-2 mb-4">
                                    {userAttachments.map((file) => {
                                        if (
                                            modelSupportedExtensionsMap[ModelTypes.VISION].image.includes(
                                                `.${file.extension}`
                                            )
                                        ) {
                                            return <ImagePreview key={file.fileId} itemId={file.fileId} />;
                                        }

                                        return (
                                            <div
                                                key={file.fileId}
                                                className="flex items-center justify-between bg-gray-50 p-2 rounded mt-2"
                                            >
                                                <div className="flex items-center gap-2">
                                                    <FileText className="h-4 w-4 text-gray-500" />
                                                    <span className="text-sm text-black truncate max-w-[180px]">
                                                        {file.fileName}
                                                    </span>
                                                </div>
                                                {file.sender === 'assistant' &&
                                                    file.status &&
                                                    file.status === FileGenerationStatus.IN_PROGRESS && (
                                                        <Loader2 className="h-4 w-4 animate-spin text-primary" />
                                                    )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                            {generation.searchSources && generation.searchSources.length > 0 && <SearchSources sources={generation.searchSources} />}
                            {generation.thinkContent && (
                                <ExpandableThinkContainer
                                    content={generation.thinkContent ?? ''}
                                    isThinking={generation.isThinking}
                                    className='mb-2'
                                />
                            )}
                            {generation.isAnalyzing && !(generation.thinkContent && (generation.isThinking || !generation.content)) &&
                                <AnalyzingIndicator isAnalyzingStep={false} isAnalyzing={true} />}
                            {generation.isAnalyzed &&
                                <AnalyzingIndicator
                                    isAnalyzingStep={true}
                                    isAnalyzing={false}
                                    codeExecutionSteps={(generation as any).codeExecutionSteps}
                                />}
                            {/* {generation.content && message.toolsStatus && message.toolsStatus[Tools.SEARCH] && (
            <span className="inline-block italic bg-[#e9e9e980] px-2 py-1 rounded my-1">
              {t('SEARCH_RESULT')}:{' '}
            </span>
          )} */}
                            {generation.content === 'EagleGpt is typing...' ? (
                                <div className="flex items-center gap-2 py-2">
                                    <span className="text-sm italic text-primary text-shimmer">
                                        EagleGpt is typing...
                                    </span>
                                </div>
                            ) : (
                                <ReactMarkdown
                                    remarkPlugins={[remarkGfm]}
                                    rehypePlugins={[rehypeRaw]}
                                    components={{
                                        h1: ({ children }: any) => (
                                            <h1 className="text-[32px] font-bold mb-2 last:mb-0">{children}</h1>
                                        ),
                                        h2: ({ children }: any) => (
                                            <h2 className="text-[24px] font-semibold mb-2 last:mb-0">{children}</h2>
                                        ),
                                        h3: ({ children }: any) => (
                                            <h3 className="text-[18.72px] font-semibold mb-2 last:mb-0">{children}</h3>
                                        ),
                                        h4: ({ children }: any) => (
                                            <h4 className="text-[16px] font-medium mb-2 last:mb-0">{children}</h4>
                                        ),
                                        h5: ({ children }: any) => (
                                            <h5 className="text-[13.28px] font-medium mb-2 last:mb-0">{children}</h5>
                                        ),
                                        h6: ({ children }: any) => (
                                            <h6 className="text-[10.72px] font-medium mb-2 last:mb-0">{children}</h6>
                                        ),
                                        p: ({ children }: any) => <p className={`mb-2 last:mb-0 break-words text-sm font-normal py-2 ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[#27272C]'}`}>{children}</p>,
                                        ul: ({ children }: any) => <ul className="list-disc pl-4 mb-2">{children}</ul>,
                                        ol: ({ children }: any) => <ol className="list-decimal pl-4 mb-2 px-3 py-4">{children}</ol>,
                                        li: ({ children }: any) => <li className="mb-0.5">{children}</li>,
                                        code: ({ inline, className, children, ...props }: any) => {
                                            const match = /language-(\w+)/.exec(className || '');
                                            if (!inline && match) {
                                                return (
                                                    <SyntaxHighlighter
                                                        style={dracula}
                                                        language={match[1]}
                                                        PreTag="pre"
                                                        customStyle={{
                                                            backgroundColor: '#282C34',
                                                            padding: '1rem',
                                                            borderRadius: '0.375rem',
                                                            overflowX: 'auto',
                                                            fontSize: '0.875rem',
                                                        }}
                                                        {...props}
                                                    >
                                                        {String(children).replace(/\n$/, '')}
                                                    </SyntaxHighlighter>
                                                );
                                            }
                                            return (
                                                <code
                                                    className="bg-gray-700 text-gray-100 rounded px-1 py-0.5 font-mono text-sm"
                                                    {...props}
                                                >
                                                    {children.trim()}
                                                </code>
                                            );
                                        },
                                        pre: ({ children }: any) => (
                                            <pre className="w-full bg-gray-800 text-gray-100 rounded p-2 overflow-x-auto mb-2">
                                                {children}
                                            </pre>
                                        ),
                                        blockquote: ({ children }: any) => (
                                            <blockquote className="border-l-4 border-gray-600 pl-4 italic mb-2">
                                                {children}
                                            </blockquote>
                                        ),
                                        table: ({ children }: any) => (
                                            <div className="mb-2 overflow-x-auto">
                                                <Table>{children}</Table>
                                            </div>
                                        ),
                                        thead: ({ children }: any) => <TableHeader>{children}</TableHeader>,
                                        tbody: ({ children }: any) => <TableBody>{children}</TableBody>,
                                        tr: ({ children }: any) => <TableRow>{children}</TableRow>,
                                        th: ({ children }: any) => <TableHead>{children}</TableHead>,
                                        td: ({ children }: any) => <TableCell>{children}</TableCell>,
                                        a: ({ href, children }: any) => (
                                            <a
                                                href={href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="bg-gray-100 rounded px-1 py-0.5 text-xs ml-1 text-gray-500 hover:text-gray-700"
                                            >
                                                {children}
                                            </a>
                                        ),
                                    } as any}
                                >
                                    {contentWithHighlightedMentions}
                                    {/* {generation.content} */}
                                </ReactMarkdown>
                            )}
                        </div>

                    </div>
                    {message.role === MessageRole.ASSISTANT_CHAT && (

                        <ReplyButton hasParticipantsArray={hasParticipantsArray} hasRemovedParticipantsArray={hasRemovedParticipantsArray} message={message} generation={generation} setReplyMessage={setReplyMessage} />
                        // <DropdownMenu
                        //     modal={false}
                        //     open={openDropdownId === generation.id}
                        //     onOpenChange={(open) => setOpenDropdownId(open ? generation.id : null)}
                        // >
                        //     <DropdownMenuTrigger asChild>
                        //         <button className="w-4 h-4 ml-2 rounded-full object-cover cursor-pointer hover:opacity-70 transition-opacity">
                        //             <EllipsisVertical className="w-4 h-4" />
                        //         </button>
                        //     </DropdownMenuTrigger>
                        //     <DropdownMenuContent className="w-40 rounded-lg p-2 shadow-lg border bg-background" align="end">
                        //         <DropdownMenuGroup>
                        //             <DropdownMenuItem onClick={() => {
                        //                 const repliedUser = hasParticipantsArray.find(participant => participant.itemId === message.senderId || currentUser?.id);
                        //                 // console.log('Reply to message:', repliedUser);
                        //                 const replyMessageData: ReplyMessageData = {
                        //                     generation: generation,
                        //                     repliedUser: repliedUser,
                        //                 };
                        //                 setReplyMessage(replyMessageData);
                        //                 setOpenDropdownId(null);
                        //             }}>
                        //                 <img src={replyIcon} alt="reply" className="w-4 h-4 mr-2" />
                        //                 <span className={`text-sm font-normal ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[text-[#555555]]'}`}>
                        //                     Reply
                        //                 </span>
                        //             </DropdownMenuItem>
                        //             <DropdownMenuItem onClick={() => {
                        //                 console.log('Comment on message:', generation.id);
                        //                 setCommentMessage(message);
                        //                 setOpenDropdownId(null);
                        //             }}>
                        //                 <img src={commentIcon} alt="copy" className="w-4 h-4 mr-2" />
                        //                 <span className={`text-sm font-normal ${theme === 'dark' ? 'text-[#ffffff]' : 'text-[text-[#555555]]'}`}>
                        //                     Comment
                        //                 </span>
                        //             </DropdownMenuItem>
                        //         </DropdownMenuGroup>
                        //     </DropdownMenuContent>
                        // </DropdownMenu>
                    )}
                </div>


                <>
                    {(message.role === MessageRole.ASSISTANT_CHAT || message.role === MessageRole.ASSISTANT) &&
                        assistantAttachments &&
                        assistantAttachments.length > 0 && (
                            <div className="flex flex-wrap justify-start gap-2 mb-2">
                                {assistantAttachments.map((file) => (
                                    <AssistantAttachmentPreview key={file.fileId} file={file} hasParticipants={true} />
                                ))}
                            </div>
                        )}
                </>
                <>
                    {(message.role === MessageRole.ASSISTANT_CHAT || message.role === MessageRole.ASSISTANT) &&
                        assistantGeneratedImages &&
                        assistantGeneratedImages.length > 0 && (
                            <div className="flex flex-wrap justify-start gap-2 mb-2">
                                {assistantGeneratedImages.map((file) => (
                                    <AssistantAttachmentPreview key={file.fileId} file={file} hasParticipants={true} />
                                ))}
                            </div>
                        )}
                </>
                <>
                    {(message.role === MessageRole.ASSISTANT_CHAT || message.role === MessageRole.ASSISTANT) &&
                        sources &&
                        sources.length > 0 && (
                            <div className="flex items-start justify-start gap-2 mb-2 ml-4">
                                <p className="text-[10px] font-semibold">{t('SOURCES')}:</p>
                                <div className="flex flex-wrap justify-start gap-2 mb-2">
                                    {sources.map((source) => (
                                        <SourceFile key={source.fileId} sourceFile={source} />
                                    ))}
                                </div>
                            </div>
                        )}
                </>
                <div>
                    {(message.role == MessageRole.ASSISTANT_CHAT || message.role == MessageRole.ASSISTANT) && !(generation?.isThisGenerationOnGoing ?? false) && (
                        <>
                            {!hideButtons && (
                                <div className="flex  md:gap-2 lg:gap-2  justify-start">
                                    {message.generations.length > 1 && (
                                        <ChangeMessage
                                            recordId={message.recordId}
                                            currentMessageIndex={message.activeGenerationIndex ?? 0}
                                            totalMessageCount={message.generations.length}
                                        />
                                    )}
                                    {!hasParticipants && copyChatBubbleIcons.map((icon) => (
                                        <button
                                            title={icon.tooltip}
                                            key={icon.type}
                                            className="flex items-center justify-center h-8 w-8 pl-0 pr-1.5 py-1.5rounded-full hover:bg-muted"
                                            onClick={async () =>
                                                await icon.onClick(
                                                    generation.content,
                                                    (generation.generatedImages ?? []).length > 0,
                                                    (generation.generatedImages ?? []).length > 0
                                                        ? (generation.generatedImages ?? [])[0].fileId
                                                        : undefined
                                                )
                                            }
                                        >
                                            {icon.icon}
                                        </button>
                                    ))}
                                    {
                                        message.role === MessageRole.ASSISTANT &&
                                        !hideButtons && (
                                            <Feedback
                                                recordId={message.userRecordId ?? ''}
                                                message={generation}
                                                isStillGenerating={false}
                                                hasParticipants={true}
                                                hideRegenerateButton={
                                                    (assistantAttachments ?? []).length > 0 ||
                                                    (generation.HasFileGeneratedResponse ?? false) ||
                                                    (assistantGeneratedImages ?? []).length > 0
                                                }
                                            />
                                        )
                                    }

                                </div>
                            )}
                        </>
                    )}

                </div>
                {message.role === MessageRole.ASSISTANT_CHAT || message.role === MessageRole.ASSISTANT && <SearchRelatedImageList isSkeletonShowForImages={generation.isSkeletonShowForImages} messageId={message.recordId} imageList={generation.relatedSearcheImageList} />}
                {message.role === MessageRole.ASSISTANT_CHAT || message.role === MessageRole.ASSISTANT && <SearchRelatedVideoList isSkeletonShowForVideos={generation.isSkeletonShowForVideos} messageId={message.recordId} videoList={generation.relatedSearcheVideoList} />}
                {message.role === MessageRole.ASSISTANT_CHAT || message.role === MessageRole.ASSISTANT && <SearchRelatedList isSkeletonShowForQuestions={generation.isSkeletonShowForQuestions} messageId={message.recordId} onSendMessage={handleSendMessage} questionList={generation.relatedSearcheQuestionsList} />}
            </div>
        </>

    };

    return (
        <div
            // 294-110
            ref={messageContainerRef}
            className="w-full overflow-y-auto flex justify-center"
            style={{ maxHeight: `calc(99vh - ${chatInputHeight}px - 65px)` }}
        >
            <div className="flex flex-col gap-1.5 w-[95%] md:w-[75%] lg:w-[65%] mb-[130px]">
                {associatedAssistant && <CustomGptHeader assistant={associatedAssistant} />}
                {
                    messages
                        .filter((message) => message.role !== MessageRole.MODEL_THINKING)
                        .map((message) => {
                            if (message.role === 'conversation-created' || message.role === 'add-participant' || message.role === 'conversation-title-updated' || message.role === 'user-removed') {
                                return <ChatEvents key={message.recordId} message={message} />
                            }
                            else if (message.role === MessageRole.USER_CHAT) {
                                return <div key={message.generations[0].id} className="flex justify-end items-start gap-0.5 mb-2">
                                    <div className="max-w-[90%] relative">
                                        {messageBubbleUi(message, 0)}
                                        <div className="flex items-center gap-3 mb-1.5 justify-end flex-wrap mr-1">

                                            <span className={`text-xs font-normal ${theme === 'dark' ? 'text-[#F3F3F3]' : 'text-[#585858]'}`}>
                                                You
                                            </span>

                                            <div className={`h-3 w-px ${theme === 'dark' ? 'bg-[#F3F3F3]' : 'bg-[#585858]'}`} />

                                            {message.generations[0].createdDate && (
                                                <TooltipProvider>
                                                    <Tooltip>
                                                        <TooltipTrigger asChild>
                                                            <span className={`text-xs ${theme === 'dark' ? 'text-[#F3F3F3]' : 'text-[#585858]'} cursor-pointer`}>
                                                                {formatDayAndTime(new Date(message.generations[0].createdDate))}
                                                            </span>
                                                        </TooltipTrigger>
                                                        <TooltipContent>
                                                            <p>{formatTimeWithAMPM(new Date(message.generations[0].createdDate))}</p>
                                                        </TooltipContent>
                                                    </Tooltip>
                                                </TooltipProvider>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            } else if (streamingMessage && streamingMessage.recordId === message.recordId && isLoading &&
                                !message.generations[message.activeGenerationIndex ?? 0].isAnalyzing &&
                                !message.generations[message.activeGenerationIndex ?? 0].isAnalyzed) {
                                return <MessageLoading key={message.recordId} />
                            } else if (streamingMessage &&
                                streamingMessage.recordId === message.recordId &&
                                isStillGenerating) {
                                return (
                                    <div key={message.recordId} className="flex justify-start items-start gap-1">
                                        <img
                                            className="w-7 h-7 border-[1px] p-1 rounded-full outline-gray-200 bg-primary-50"
                                            src={logo}
                                            alt="eagle app"
                                        />
                                        <div className="max-w-[90%] relative">
                                            {messageBubbleUi(
                                                message,
                                                message.activeGenerationIndex ?? 0,
                                                true
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                            else if (message.role === MessageRole.ASSISTANT && !(message.generations[message.activeGenerationIndex ?? 0].isAnalyzing ?? false)) {
                                return (
                                    <div key={message.recordId} className="flex justify-start items-start gap-1 mb-2">
                                        <img
                                            className="w-7 h-7 border-[1px] p-1 rounded-full outline-gray-200 bg-primary-50"
                                            src={logo}
                                            alt="eagle app"
                                        />
                                        <div className="max-w-[90%] relative">
                                            {messageBubbleUi(
                                                message,
                                                message.activeGenerationIndex ?? 0,
                                                false
                                            )}
                                        </div>
                                    </div>
                                );
                            }

                            else if (message.role === MessageRole.ASSISTANT_CHAT &&
                                (message.generations[message.activeGenerationIndex ?? 0].content || message.generations[message.activeGenerationIndex ?? 0].isAnalyzing)) {
                                const participant = message.senderId
                                    ? hasParticipantsArray.find(p => p.itemId === message.senderId)
                                    || hasRemovedParticipantsArray.find(p => p.itemId === message.senderId)
                                    : null;
                                return (
                                    <div key={message.generations[0].id} className="flex justify-start items-start gap-1 mb-2">
                                        {participant?.profileImageUrl ? (
                                            <img

                                                className="w-7 h-7 mt-[8px] border-[1px] rounded-full object-cover"
                                                src={participant.profileImageUrl}
                                                alt={`${participant.firstName}${participant.lastName ? ` ${participant.lastName}` : ''}`}
                                            />
                                        ) : (
                                            <img
                                                className="w-7 h-7 mt-[8px] border-[1px] rounded-full"
                                                src={userParticipant}
                                                alt="participant"
                                            />
                                        )}
                                        <div className="max-w-[90%] relative">
                                            {messageBubbleUi(message, 0)}
                                            {message.senderId && (
                                                <div className="flex items-center gap-3 mb-1.5 justify-start flex-wrap ml-2 mr-1">
                                                    <span className={`text-xs font-medium ${theme === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
                                                        {participant ? `${participant.firstName}${participant.lastName ? ` ${participant.lastName}` : ''}` : ''}
                                                    </span>
                                                    <div className={`h-3 w-px ${theme === 'dark' ? 'bg-gray-600' : 'bg-gray-300'}`} />
                                                    {message.generations[message.activeGenerationIndex ?? 0].createdDate && (
                                                        <TooltipProvider>
                                                            <Tooltip>
                                                                <TooltipTrigger asChild>
                                                                    <span className={`text-xs ${theme === 'dark' ? 'text-gray-500' : 'text-gray-400'} cursor-pointer`}>
                                                                        {formatDayAndTime(new Date(message.generations[message.activeGenerationIndex ?? 0].createdDate!))}
                                                                    </span>
                                                                </TooltipTrigger>
                                                                <TooltipContent>
                                                                    <p>{formatTimeWithAMPM(new Date(message.generations[message.activeGenerationIndex ?? 0].createdDate!))}</p>
                                                                </TooltipContent>
                                                            </Tooltip>
                                                        </TooltipProvider>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        })
                }

                <div ref={messagesEndRef} />
            </div>

            <div className="flex justify-center absolute w-[85%] md:w-[50%] lg:w-[50%]"
                style={{ bottom: `${chatInputHeight}px` }}
            >
                <Button
                    ref={scrollToBottomButton}
                    variant="outline"
                    aria-label="Scroll to bottom"
                    className="h-10 rounded-full border w-10 z-50"
                    onClick={scrollToBottom}
                >
                    <ArrowDown size={16} />
                </Button>
            </div>
        </div>
    );
};



// card 1: Mention participants
//       1-> 
//       2-> Fixing ui
//       3-> Adding mention feature in the ui
//       4-> Implementing mention feature with the backend